import React, { useState } from 'react';
import './HeroWithTabs.css';

const HeroWithTabs = () => {
  const [activeTab, setActiveTab] = useState('premium-kundli');

  const tabs = [
    { id: 'consult', label: 'Talk to Astrologers' },
    { id: 'kundli', label: 'Chat With Astrologers' },
    { id: 'premium-kundli', label: 'Premium Kundli' },
    { id: 'remedies', label: 'Remedies' }
  ];

  const tabContent = {
    daily: {
      color: 'bg-astro-cardGreen',
      title: 'Start your day with clarity',
      desc: 'Get personalized daily predictions tailored to your moon sign. Know exactly when to act and when to pause.',
      btn: 'Download App',
      
      visual: (
        <div className="phone-mockup-tabs">
          <div className="phone-notch-tabs"></div>
          <div className="phone-screen-tabs-daily">
            <div className="forecast-icon-wrapper">
              <div className="forecast-icon">☀️</div>
            </div>
            <h4 className="forecast-title">Today's Forecast</h4>
            <p className="forecast-text">The moon brings clarity to your career sector today.</p>
          </div>
        </div>
      )
    },
    'premium-kundli': {
      color: 'bg-astro-cardGreen',
      title: 'Start your day with clarity',
      desc: 'Get personalized daily predictions tailored to your moon sign. Know exactly when to act and when to pause.',
      btn: 'Download App',
    
      visual: (
        <div className="phone-mockup-tabs">
          <div className="phone-notch-tabs"></div>
          <div className="phone-screen-tabs-daily">
            <div className="forecast-icon-wrapper">
              <div className="forecast-icon">☀️</div>
            </div>
            <h4 className="forecast-title">Today's Forecast</h4>
            <p className="forecast-text">The moon brings clarity to your career sector today.</p>
          </div>
        </div>
      )
    },
    kundli: {
      color: 'bg-astro-cardPurple',
      title: 'Understand your destiny',
      desc: 'Dive deep into your Vedic birth chart. Our detailed Dosha Analysis helps you uncover hidden strengths and life patterns.',
      btn: 'Download App',
    
      visual: (
        <div className="phone-mockup-tabs">
          <div className="phone-notch-tabs"></div>
          <div className="phone-screen-tabs-kundli">
            <div className="kundli-chart">NORTH INDIAN CHART</div>
            <h4 className="forecast-title">Rashi: Aries</h4>
            <p className="forecast-text">Nakshatra: Ashwini</p>
          </div>
        </div>
      )
    },
    consult: {
      color: 'bg-astro-cardBlue',
      title: 'Expert advice, instant answers',
      desc: 'Connect with India\'s top Vedic astrologers via video call or chat. Get solutions for love, career, and finance issues instantly.',
      btn: 'Download App',
     
      visual: (
        <div className="consult-visual">
          <div className="consult-card">
            <div className="consult-avatar">👨‍🦲</div>
            <div className="consult-status">
              <span className="status-dot"></span>
              <span>Online Now</span>
            </div>
          </div>
          <div className="consult-video-icon">📹</div>
        </div>
      )
    },
    remedies: {
      color: 'bg-astro-softYellow',
      title: 'Remedies that actually work',
      desc: 'Discover the right gemstones, mantras, and simple rituals to overcome obstacles and attract positive energy into your life.',
      btn: 'Download App',
    
      visual: (
        <div className="remedies-visual">
          <div className="gem-circle">
            <div className="gem-icon">💎</div>
            <div className="gem-label-top">Ruby</div>
            <div className="gem-label-bottom">Emerald</div>
          </div>
        </div>
      )
    }
  };

  const currentContent = tabContent[activeTab];

  const handleDownloadClick = () => {
    const heroSection = document.getElementById('home');
    if (heroSection) {
      heroSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  return (
    <section id="services" className="hero-tabs-section">
      <div className="hero-tabs-container">
        <h2 className="hero-tabs-title">Understand your destiny <br />and purpose with AstroIndia</h2>
        
        <div className="tabs-container">
          {tabs.map((tab) => (
            <button
              key={tab.id}
              className={`tab-button ${activeTab === tab.id ? 'active' : ''}`}
              onClick={() => setActiveTab(tab.id)}
            >
              {tab.label}
            </button>
          ))}
        </div>

        <div className={`hero-tabs-content ${currentContent.color}`}>
          <div className="hero-tabs-panel">
            <div className="phone-display">
              {currentContent.visual}
            </div>
            
            <div className="hero-tabs-text">
              <h3 className="tabs-content-title">{currentContent.title}</h3>
              <p className="tabs-content-description">
                {currentContent.desc}
              </p>
              <button className="forecast-cta-button" onClick={handleDownloadClick}>
                <span className="eye-icon">{currentContent.icon}</span>
                {currentContent.btn}
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroWithTabs;

